import { render, staticRenderFns } from "./DtClass.vue?vue&type=template&id=39a040f3&"
import script from "./DtClass.vue?vue&type=script&lang=js&"
export * from "./DtClass.vue?vue&type=script&lang=js&"
import style0 from "./DtClass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports